import { Component, ViewChild } from '@angular/core';
import { MachineHistorySearchComponent } from '../../Core/Shared/MachineHistoryComponent/MachineHistorySearch.component';

@Component({
  selector: 'WaterProcessMachineHistory',
  templateUrl: './WaterProcessMachineHistory.component.html',

})
export class WaterProcessMachineHistoryComponent {
}